import React, { useState, useMemo } from "react";
import Divider from "@mui/material/Divider";
import { MaterialStyled } from "./material.style";
import { EncircledPlusIcon } from "../../../utils/svg-components";
import Accordian from "../../../components/accordian/accordian";
import { Typography } from "@mui/material";
import { Button } from "../../../components/button/button";
import MaterialRow from "./material-row/MaterialRow";
import { formatNumber } from "../../../utils/utils";

const MaterialBody = ({
  materials,
  onTaskChange,
  onDelete,
  onAdd,
  isGeneralUser,
}) => (
  <>
    {/* Render the single material row */}
    <div className="material-body">
      {materials.map((task, index) => (
        <div key={index}>
          <MaterialRow
            task={task}
            taskIndex={index}
            materialIndex={index}
            onTaskChange={onTaskChange}
            onDelete={onDelete}
            isGeneralUser={isGeneralUser}
          />
          {index < materials.length - 1 && <Divider sx={{ my: 2 }} />}
        </div>
      ))}
    </div>
    {/* Optionally show an "Add Material" button */}
    {!isGeneralUser && (
      <div className="add-material">
        <Button
          onClick={onAdd}
          startIcon={<EncircledPlusIcon />}
          size="large"
          variant="filled"
          color="tertiary"
        >
          Add Material
        </Button>
      </div>
    )}
  </>
);

const Material = ({
  materials,
  handleMaterialTaskChange,
  handleAddMaterialTask,
  handleMaterialDeleteTask,
  isGeneralUser,
}) => {
  const [expanded, setExpanded] = useState([""]);

  const totalBudget = useMemo(() => {
    return materials.reduce((sum, mat) => sum + parseFloat(mat.total || 0), 0);
  }, [materials]);

  const headerContent = useMemo(
    () => (
      <div className="material-budget">
        <Typography variant="h5">Materials</Typography>
        <Typography variant="h5">$ {formatNumber(totalBudget)}</Typography>
      </div>
    ),
    [totalBudget]
  );

  return (
    <MaterialStyled isGeneralUser={isGeneralUser}>
      <Accordian
        name="material"
        handleChange={setExpanded}
        expanded={expanded.includes("material") ? "material" : ""}
        variant="purple"
        arrowPosition="right"
        heading={headerContent}
        body={
          <MaterialBody
            materials={materials}
            onTaskChange={handleMaterialTaskChange}
            onDelete={handleMaterialDeleteTask}
            onAdd={handleAddMaterialTask}
            isGeneralUser={isGeneralUser}
          />
        }
      />
    </MaterialStyled>
  );
};

export default React.memo(Material);
